import type { Pinia, PiniaPluginContext, Store } from 'pinia'
import { useLogger } from '@/composables/useLogger.ts'
import { type StoreCache } from '@/composables/useStoreCache.ts'

const logger = useLogger('piniaClearStorePlugin')
const AllPiniaStores = new Set<Store>()

export interface PiniaTitropExtended extends Pinia {
  $resetAll: () => void
  $clearCaches: () => void
  stores: () => Store[]
}

export function piniaClearStorePlugin(context: PiniaPluginContext) {
  AllPiniaStores.add(context.store)
  ;(context.pinia as PiniaTitropExtended).stores = () => Array.from(AllPiniaStores.values())
  ;(context.pinia as PiniaTitropExtended).$resetAll = function () {
    AllPiniaStores.forEach((s) => {
      s.$reset()
    })
    logger.info('All pinia stores cleared')
  }
  ;(context.pinia as PiniaTitropExtended).$clearCaches = function () {
    AllPiniaStores.forEach((s: Store & { $cache?: StoreCache }) => {
      if (s.$cache) {
        s.$cache.clear()
      }
      // Object.keys(localStorage)
      //   .filter((s) => s.endsWith('-generated-store'))
      //   .forEach((store) => {
      //     const storeContent = JSON.parse(localStorage[store])
      //     storeContent.$cache = {}
      //     localStorage.setItem(store, JSON.stringify(storeContent))
      //   })

      logger.info('All pinia stores cleared')
    })
  }
}
